import { FC } from 'react'
import { useLoading } from '@/hooks/use-loading'
import { Progress } from '@lifedot/components/Progress'

export const LoadingHandler: FC = () => {
  const isLoading = useLoading()

  return isLoading ? <Progress /> : null
}
